import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { FullWidthFieldsContainer, LocalizedTypography } from '@mews-commander/ui';
import { CheckboxField, InputField } from '@mews-commander/legacy-form';
import ReceiverSelectField from '../../ReceiverSelectField';

interface Props {
    showEmailInput: boolean;
    showEmailTypeSelect: boolean;
    showEmailToBookerHint: boolean;
}

const receiverSelectProps = {
    label: <LocalizedText textKey={TextKey.Email} />,
    name: 'confirmationEmailType',
};
const checkboxFieldProps = {
    label: <LocalizedText textKey={TextKey.SendConfirmationEmail} />,
    name: 'sendConfirmationEmail',
};

const customEmailProps = {
    label: <LocalizedText textKey={TextKey.CustomEmail} />,
    name: 'confirmationCustomEmail',
    required: true,
};
const ReservationConfirmationForm = ({ showEmailInput, showEmailTypeSelect, showEmailToBookerHint }: Props) => (
    <FullWidthFieldsContainer>
        <CheckboxField {...checkboxFieldProps} />
        {showEmailToBookerHint ? (
            <LocalizedTypography textStyle="bodySmall" textKey={TextKey.SendEmailToBookerHint} as="div" />
        ) : null}
        {showEmailTypeSelect ? <ReceiverSelectField {...receiverSelectProps} /> : null}
        {showEmailTypeSelect && showEmailInput ? <InputField {...customEmailProps} /> : null}
    </FullWidthFieldsContainer>
);

export default ReservationConfirmationForm;
